import { useEffect } from "react";
import { useLocation } from "react-router";

import { aleaApm } from "@/v2/utils/configureApm";

export const ApmRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!aleaApm) return;

    const transaction = aleaApm.startTransaction(location.pathname, "page-load");

    return () => {
      transaction?.end();
    };
  }, [location.pathname]);

  return null;
};

export default ApmRouteTracker;
